module.exports = __webpack_public_path__ + "img/patreon.bb1935a8.png";